export enum FormPage {
    personalInformation = 1,
    background = 2,
    education = 3,
    disclosure = 4
}
